module.exports = __webpack_public_path__ + "static/img/privacy_count_1.5a7f5446.svg";